export default __webpack_public_path__ + "static/media/people-image.1105fc1f.png";